import {Badge} from '@common-web/components/ui/badge';
import {cn} from '@common-web/lib/utils';

export type TableHeaderCountProps = {
  count: number;
  singular: string;
  plural: string;
  className?: string;
};

/** Total-count badge for list/table card headers (brand blue pill). */
export function TableHeaderCount({count, singular, plural, className}: TableHeaderCountProps) {
  const noun = count === 1 ? singular : plural;
  return (
    <Badge
      className={cn('bg-brand-blue/10 text-brand-blue border-0 font-medium px-3 py-1', className)}
    >
      {count} {noun}
    </Badge>
  );
}
